import DeveloperController, {
  DeveloperPageProps,
} from "../../../controller/precon/precondeveloper.controller";
import { GetServerSideProps, NextPage } from "next";
import useQuery from "../../../hooks/usePreConQuery";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";

const NotListing = dynamic(
  () => import("../../../Layout/PreConListing/NotListing"),
  {
    suspense: true,
  }
);

const Card = dynamic(
  () => import("../../../components/PreConstruction/PreConCard"),
  {
    suspense: true,
  }
);

const Pagination = dynamic(() => import("rc-pagination"), { suspense: true });

const Filters = dynamic(() => import("../../../Layout/PreConListing/Filters"), {
  suspense: true,
});

const Developer: NextPage<DeveloperPageProps> = ({
  query,
  developer,
  properties,
}) => {
  const queries = useQuery(query);
  return (
    <>
      <Head>
        <title>
          New Bungalows For Sale By {developer.label} | Bungalow Finder
        </title>
        <meta name="title" content="New Bungalows For Sale | Bungalow Finder" />
        <meta
          name="description"
          content="New Bungalows For Sale | Bungalow Finder"
        />
      </Head>
      <div className="flex-1 flex flex-col">
        <div className="z-10">
          <div className="bg-gray-200 text-primary py-3">
            <div className="container mx-auto flex">
              <Suspense
                fallback={
                  <>
                    <p>Loading...</p>
                  </>
                }
              >
                <Filters query={query} queries={queries} />
              </Suspense>
            </div>
          </div>
        </div>
        <div className="w-full mx-auto container ">
          <div className="flex md:justify-between justify-center flex-wrap items-center">
            <div className="px-2 py-3 flex justify-center md:justify-between items-center flex-wrap">
              <h1 className="font-normal line-clamp-1 text-xl">
                New Bungalows by {developer.label}
              </h1>
            </div>
            <div className="px-2">
              <label>
                Sort by:
                <select
                  onChange={(e) => {
                    queries.push({
                      sortby: e.currentTarget.value,
                    });
                  }}
                  // defaultValue={query.sortby}
                  className="bg-transparent w-24 whitespace-nowrap"
                >
                  <option value="lts">New Listings</option>
                  <option value="ols">Oldest Listings</option>
                  <option value="lth">Price-Low To Hight Listings</option>
                  <option value="htl">Price-Hight To Low Listings</option>
                </select>
              </label>
            </div>
          </div>

          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            {properties.property.length !== 0 ? (
              <div
                className={`px-2 py-1 grid overflow-hidden grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8`}
              >
                {properties.property.map((property, index) => (
                  <Card key={index} item={property} />
                ))}
              </div>
            ) : (
              <>
                <Suspense
                  fallback={
                    <>
                      <p>Loading...</p>
                    </>
                  }
                >
                  <NotListing />
                </Suspense>
              </>
            )}
          </Suspense>
          <div className="px-2 py-5 text-center">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Pagination
                total={properties.total}
                pageSize={12}
                defaultCurrent={1}
                onChange={(page) => {
                  queries.push({
                    page,
                  });
                }}
              />
            </Suspense>
          </div>
          <hr />
          <div
            className="px-2 py-5 element"
            dangerouslySetInnerHTML={{
              __html: (developer.content && developer.content) || "",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Developer;

export const getServerSideProps: GetServerSideProps = async (context) => {
  return await DeveloperController(context);
};
